import React, { Component } from 'react';

import withJsScript from 'client/helpers/withJsScript';

const { NODE_ENV } = process.env;

@withJsScript({
  scriptUrl: 'https://js-na1.hs-scripts.com/21782685.js',
})
class UPHubspotWidgetJS extends Component {
  render() {
    return null;
  }
}

const UPHubspotWidget = () => {
  if (NODE_ENV !== 'production') {
    return null;
  }

  return <UPHubspotWidgetJS />;
};

export default UPHubspotWidget;
